import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"

//import axios from 'axios';
import axios_api from "../../Api";

import { API_URL, AUTH_TOKEN } from '../../Context';
import ConfirmationModal from './ConfirmationModal';


export function TicketCreateForm ({year, queue}) {

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)
  const [themes, setThemes] = useState([]);
  const [themesLoading, setThemesLoading] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  React.useEffect(() => {

    let ticketThemes = axios_api.get(api_url + '/ticket_themes/', {
      headers: {"Authorization": token},
      params: {"queue": queue}
    });

    ticketThemes.then(
      (result) => {
        setThemes(result.data);
        setThemesLoading(false);
      },
      (error) => {
        setFormError('Не удалось загрузить темы обращений, обновите страницу');
        setThemesLoading(false);
        console.log(error);
      }
    );

  }, [api_url, token, queue]);


  const onSubmit = (ticketData) => {

    let params = {'year': year, 'queue': queue};
    let data = {...ticketData, ...params};

    console.log(data);

    axios_api.post(api_url + `/ticket/`, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("Document uploaded");
        navigate("/tickets");
        navigate(0);
      },
      (error) => {
        const errorMessage = error.request.status === 413 ? 
            'Размер файла превышает разрешенный размер на web-сервере' : 
              error.response?.data || 
                'Ошибка добавления документа';
        setFormError(errorMessage);
        //console.log(error);
      }
    );
  }

  return (
    <>
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group my-3">
          <label className="mt-3 col-4">
            <p>Тема обращения</p>
            <select
              className={errors.theme ? "form-select is-invalid" : "form-select"}
              style={{width: '500px'}}
              defaultValue=""
              {...register("theme", {required: 'Выберите тему обращения'})}
            >
              <option value="" disabled>Выберите тему обращения</option>
              {themes.map((theme) =>
                <option key={theme.id} value={theme.id}>{theme.theme_name}</option>
              )}
            </select>
            { errors.theme &&
              <p className="text-danger mt-1"><small>{errors.theme.message}</small></p>
            }
          </label>
        </div>
        <div className="input-group my-3">  
          <label className="mt-3 col-4">
            <p>Напишите сообщение</p>
            <textarea className="form-control" rows="3"  style={{width: '500px'}} {...register("text")} ></textarea>
          </label>
        </div>
        <div className="input-group mt-3">
          <label className="">
            <p>Приложенный файл</p> 
            <input type="file" className="form-control" style={{width: '500px'}} {...register('attachment')}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{formError}</p>
        }
        {(!themesLoading && !formError && themes.length === 0) &&
          <p className="text-danger">Нет доступных тем обращений, пожалуйста свяжитесь с АСНП ЦВКК</p>
        }
        {themes.length > 0 ?
          <button type="submit" className="btn lk-button my-3">Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
    </div>
    </>  
  )
}


export function TicketUpdateForm ({ ticketId }) {

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)
  const [closeError, setCloseError] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });


  const onSubmit = (ticketData) => {

    let data = {...ticketData};

    console.log(data);

    axios_api.put(api_url + `/ticket/` + ticketId, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("success");
        navigate("/ticket/" + ticketId);
        navigate(0);
      },
      (error) => {
        const errorMessage = error.request.status === 413 ? 
            'Размер файла превышает разрешенный размер на web-сервере' : 
              error.response?.data || 
                'Ошибка добавления документа';
        setFormError(errorMessage);
        //console.log(error.response.data);
      }
    );
  }

  function CloseTicketClick() {
    axios_api.put(api_url + `/ticket/` + ticketId, { operation: 'close' }, {
      headers: {"Authorization": token}
    })
    .then(
      (result) => {
        navigate("/ticket/" + ticketId);
        navigate(0);
      },
      (error) => {
        setCloseError(error.response?.data || 'Не удалось закрыть обращение');
        console.log(error);
      }
    );
  }

  return (
    <>
    <ConfirmationModal
      modalId="confirmTicketCloseModal"
      headerText="Обращение"
      messageText={[
        "Вы уверены, что хотите закрыть обращение?",
        "После этого в него нельзя будет добавить сообщения"
      ]}
      confirmButtonText="Закрыть обращение"
      Action={() => CloseTicketClick()}
      //danger
    />
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group mb-3">  
          <label className="col-4">
            <p>Сообщение</p>
            <textarea className="form-control" rows="2"  style={{width: '400px'}} {...register("text")} ></textarea>
          </label>
        </div>
        <div className="input-group mt-3">
          <label className="">
            <p>Вложение</p> 
            <input type="file" className="form-control" style={{width: '400px'}} {...register('attachment')}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{formError}</p>
        }
        {(20 > 10) ?
          <button type="submit" className="btn lk-button my-3">Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
      {ticketId &&
        <button
          type="button"
          className="btn lk-button mt-4"
          data-bs-toggle="modal"
          data-bs-target="#confirmTicketCloseModal"
        >
          Закрыть обращение
        </button>
      }
      { closeError &&
        <p className="text-danger mt-3">{typeof closeError === 'string' ? closeError : 'Не удалось закрыть обращение'}</p>
      }
    </div>
    </>  
  )
}
